import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { appInitializer } from './app-initializer';
import { LoginComponent } from './views/auth/login/login.component';
import { NotFoundComponent } from './views/errors/not-found/not-found.component';
import { ForgotPasswordComponent } from './views/auth/forgot-password/forgot-password.component';
import { SharedModule } from './core/shared.module';
import { AuthComponent } from './views/auth/auth-wrapper.component';
import { authInterceptor } from './core/auth/auth.interceptor';
import { ResetPasswordComponent } from './views/auth/reset-password/reset-password.component';
import { serverErrorInterceptor } from './core/interceptors/server-error.interceptor';
import { ThemeService } from './core/services/theme.service';
import { MaterialModule } from './material/material.module';
import { ErrorDirective } from './standalone/error/error.directive';
import { ConfirmationComponent } from './core/modules/confirmation/confirmation.component';

import { ShownApiErrorFilter } from './core/transport/shown-api-error-handler';

import * as Sentry from "@sentry/angular";

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    LoginComponent,
    NotFoundComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ConfirmationComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    MaterialModule,
    SharedModule,
    BrowserAnimationsModule,
    ErrorDirective
  ],
  providers: [
    provideAppInitializer(appInitializer),
    // Instantiating ThemeService applies the persisted light/dark theme to <body>.
    provideAppInitializer(() => {
      inject(ThemeService);
    }),
    {
      provide: ErrorHandler,
      useFactory: () => new ShownApiErrorFilter(Sentry.createErrorHandler()),
    },
    provideHttpClient(withInterceptors([
      authInterceptor,
      serverErrorInterceptor,
    ])),
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
